export const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce), (update: slow)');
export const shouldAnimate = () => !reducedMotionQuery.matches;
